import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import { useEffect, useState } from 'react';
import getOrderDetails from '../Orders/getOrderDetails';
import {ProjectConfig} from 'Global';

export default function Bag() {

    const [productQuantity, setProductQuantity] = useState(0);

    useEffect(() => {
        buildBag();
    }, []);

    return null;
}



const buildBag = async () => {
    
    const productQuantity = await getProductQuantity();


        const bagButton = document.querySelector("[pc='bag-quantity']");
        if (bagButton) {
            bagButton.addEventListener("click", async () => {
                showBag();
            });
        }
    
}


/*=========================================================
GET BAG TEMPLATE
=========================================================*/
const getBagTemplate = async (action = "") => {
    await ApiRequest({
        url: "/templates/getTemplate",
        method: "get",
        query: {
            template_name: "bag",
        },
        setResponse: (response: any) => {
            // Check if bag element already exists
            let bagElement = document.querySelector('[pc="bag"]');
            
            if (bagElement) {
                // If it exists, extract only the inner content from the template
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = response.template;
                const templateBagElement = tempDiv.querySelector('[pc="bag"]');
                
                if (templateBagElement) {
                    bagElement.innerHTML = templateBagElement.innerHTML;
                }
            } else {
                // If it doesn't exist, create a temporary container to parse the template
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = response.template;
                
                // Get the bag element from the template
                bagElement = tempDiv.querySelector('[pc="bag"]');
                
                if (bagElement) {
                    bagElement.classList.add('hidden');
                    document.body.appendChild(bagElement);
                }
            }
            
            // Add fixed positioning styles to the bag element
            if (bagElement) {
                const bagHTMLElement = bagElement as HTMLElement;
                bagHTMLElement.style.position = 'fixed';
                bagHTMLElement.style.top = '0';
                bagHTMLElement.style.left = '0';
                bagHTMLElement.style.width = '100%';
                bagHTMLElement.style.height = '100%';
                bagHTMLElement.style.zIndex = '9999';
            }
            
            
            // Store webflow pages data for navigation
            let webflowPages = response.webflow_pages || {};

            //search dinamically for pc-icon="icon_name" and replace it with the icon
            const icons = document.querySelectorAll('img[pc-icon]');
            icons.forEach((iconElement) => {
                const iconName = iconElement.getAttribute('pc-icon');
                if (iconName) {
                    const newSrc = `${ProjectConfig.api_url}/assets/icons/library/${iconName}.svg`;
                    iconElement.setAttribute('src', newSrc);
                }
            });

            /*=========================================================
            ADD LISTENER FOR BAG BACKGROUND
            =========================================================*/
            const background = document.querySelector('[pc="bag-background"]');
            background?.addEventListener("click", hideBag);

            //bag-close
            const closeButton = document.querySelector('[pc="bag-close"]');
            closeButton?.addEventListener("click", hideBag);

            //bag-view-bag-button
            const viewBagButton = document.querySelector('[pc="view-cart"]');
            viewBagButton?.addEventListener("click", async () => {
                if (webflowPages && webflowPages.cart && webflowPages.cart.slug) {
                    window.location.href = '/' + webflowPages.cart.slug;
                } else {
                    window.location.href = '/pennicart-cart';
                }
            });

            //bag-checkout-button
            const checkoutButton = document.querySelector('[pc="view-checkout"]');
            checkoutButton?.addEventListener("click", async () => {
                if (webflowPages && webflowPages.checkout && webflowPages.checkout.slug) {
                    window.location.href = '/' + webflowPages.checkout.slug;
                } else {
                    window.location.href = '/pennicart-checkout';
                }
            });

            /*=========================================================
            HANDLE BAG HEADING BASED ON ACTION
            =========================================================*/
            const bag_heading = document.querySelector('[pc="bag-heading"]');
            if (bag_heading) {
                if (action === 'add') {
                    // If action is 'add', only replace text nodes, keeping icons
                    const childNodes = Array.from(bag_heading.childNodes);
                    childNodes.forEach(node => {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.textContent = 'Added To Bag';
                        }
                    });
                } else {
                    // If action is not 'add', replace all content with 'Your bag'
                    bag_heading.innerHTML = 'Your Bag';
                }
            }
        },
    });
}


/*=========================================================
GET PRODUCT QUANTITY
=========================================================*/
export async function getProductQuantity() {
    let productQuantity = 0;
    
    try {
        const cart = JSON.parse(localStorage.getItem('cart') || '{"products":[]}');
        const cartItems = cart.products || [];
        
        // Calculate total quantity from all items in the products array
        productQuantity = cartItems.reduce((total: number, item: any) => {
            return total + (parseInt(item.quantity) || 1);
        }, 0);
        
        // Update DOM and localStorage
        const cartProductsCount = document.querySelector('[pc="bag-count"]');
        if (cartProductsCount) {
            cartProductsCount.innerHTML = productQuantity.toString();
        }
        
        localStorage.setItem('productsQuantity', productQuantity.toString());
        
        // Hide bag if cart is empty
        if (productQuantity === 0) {
            hideBag();
        }
    } catch (error) {
        console.error('Error reading cart from localStorage:', error);
        productQuantity = 0;
    }

    return productQuantity;
}

/*=========================================================
HIDE BAG
=========================================================*/
export async function hideBag() {
    const bag = document.querySelector('[pc="bag"]');
    if (bag) {
        bag.classList.add('hidden');
    }
}

/*=========================================================
SHOW BAG
=========================================================*/
export async function showBag (action = "") {

    // const bag_heading = document.querySelector('[pc="bag-heading"]');
    // if (bag_heading) {
    //     bag_heading.innerHTML = 'Your Bag';
    // }
    
    const productQuantity = localStorage.getItem('productsQuantity') || 0;
    ShowLoader(true);
    await getBagTemplate(action);

    const productItem = document.querySelector('[pc="product-item"]');
    if(Number(productQuantity) == 0){
        //hide product-item 
        if (productItem) {
            productItem.classList.add('hidden');
        }
    }
    else{
        if (productItem) {
            productItem.classList.remove('hidden');
        }
    }

    const bag = document.querySelector('[pc="bag"]');
    if (bag) {
        const cart: any = await getOrderDetails("bag");
        bag.classList.remove('hidden');
    }
    else{
        console.error('Bag template not found');
    }

    ShowLoader(false);
    
    
}
